import { Pagination } from '@shared/components/pagination/model';

export const defaultParams: Pagination = {
  start: 1,
  limit: 8,
  isMobile: true,
};
